import { render, staticRenderFns } from "./BIControlPanel.vue?vue&type=template&id=2a527dd1&"
import script from "./BIControlPanel.vue?vue&type=script&lang=js&"
export * from "./BIControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./BIControlPanel.vue?vue&type=style&index=0&id=2a527dd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports